const SELECTORS = Selectors({
  bookingForm: 'booking-form',
  slotsField: 'input[type=hidden][name=Slots]',
  selectedSlotsHolder: 'booking-selected-slots'
})

const $form = document.querySelector(SELECTORS.asClass('bookingForm'))
const $slotsField = document.querySelector(SELECTORS.slotsField)
const $selectedSlotsHolder = document.querySelector(SELECTORS.asClass('selectedSlotsHolder'))

const fn = {
  init: () => {
    if ($form && $form.classList.contains('review-step')) {
      fn.loadSlots()

      $form.addEventListener('submit', () => {
        $form.querySelector('[type=submit][name=action_finish]').style.pointerEvents = 'none'
      })
    }
  },

  getSelectedSlots: () => {
    return $slotsField.value.split(',').map(id => id.trim())
  },

  loadSlots: () => {
    const selected = fn.getSelectedSlots()

    if (selected.length) {
      $.ajax({
        type: 'get',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}fetchslotdata`,
        data: {
          slots: selected.join(',')
        },
        success: resp => fn.buildSelectedSlots(resp)
      })
    } else {
      fn.buildSelectedSlots([])
    }
  },

  buildSelectedSlots: (slots) => {
    let html = ''

    slots.forEach(slot => {
      html += `<div class="booking-selected-slot">
        <div class="booking-selected-slot__inner">
          <div class="booking-selected-slot__cost">${slot.cost}</div>
          <div class="booking-selected-slot__date">${slot.date}</div>
          <div class="booking-selected-slot__time">${slot.time}</div>
        </div>
      </div>`
    })

    $selectedSlotsHolder.innerHTML = html
    $selectedSlotsHolder.classList.toggle('is-active', html !== '')
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingrequestpage'),
  run: fn.init
}
